import { motion } from "framer-motion";
import { Music } from "lucide-react";
import { Reveal, Overline, EASE } from "./motion";
import { CHARACTERS } from "./content";

export const Characters = () => (
  <section id="turma" className="relative bg-dm-cream py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-8">
      <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <Reveal>
            <Overline color="#9D4EDD">Conheça a turma</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-5xl font-black leading-[0.9] tracking-tighter text-dm-ink md:text-6xl lg:text-7xl">
              Seis amigos,
              <br />
              seis instrumentos.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-sm text-base leading-relaxed text-dm-muted md:text-lg">
            Personagens desenhados para virar produto: silhuetas reconhecíveis a 3 metros de
            distância, expressões afetivas e uma cor própria para cada um.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CHARACTERS.map((c, i) => (
          <Reveal key={c.name} delay={(i % 3) * 0.08}>
            <motion.article
              whileHover={{ y: -8 }}
              transition={{ duration: 0.4, ease: EASE }}
              className="group relative flex h-full flex-col justify-between overflow-hidden rounded-[2rem] p-8"
              style={{ backgroundColor: c.color }}
            >
              <span
                className="pointer-events-none absolute -right-6 -top-10 font-display text-[9rem] font-black leading-none opacity-20 transition-transform duration-700 group-hover:scale-110"
                style={{ color: c.dark ? "#1A1A24" : "#FDFBF7" }}
              >
                {c.name.charAt(0)}
              </span>
              <div className={`relative z-10 grid h-12 w-12 place-items-center rounded-full ${c.dark ? "bg-dm-ink/10" : "bg-white/25"}`}>
                <Music className="h-6 w-6" style={{ color: c.dark ? "#1A1A24" : "#FDFBF7" }} />
              </div>
              <div className="relative z-10 mt-16">
                <h3
                  className="font-display text-4xl font-black tracking-tight"
                  style={{ color: c.dark ? "#1A1A24" : "#FDFBF7" }}
                >
                  {c.name}
                </h3>
                <p
                  className="mt-1 text-sm font-bold uppercase tracking-widest"
                  style={{ color: c.dark ? "rgba(26,26,36,0.65)" : "rgba(253,251,247,0.8)" }}
                >
                  {c.instrument}
                </p>
                <p
                  className="mt-3 text-base font-medium"
                  style={{ color: c.dark ? "rgba(26,26,36,0.8)" : "rgba(253,251,247,0.9)" }}
                >
                  {c.trait}
                </p>
              </div>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
